import {TimelineMax, TweenMax, Sine/* , Circ, Linear*/} from 'gsap';
const CustomEase = require('gsap/CustomEase');
const EventEmitter = require('eventemitter3');
const Snap = require('snapsvg');
// const InvalidateUtils = require('./svgAnim/InvalidateUtils');
const DrawSVGUtils = require('../../viscomjs/utils/DrawSVGUtils');
const drawSVGUtils = {};
DrawSVGUtils.mixin(drawSVGUtils);
TimelineMax, Sine

const params = {
    width1: 768,
    height1: 768,
    width2: 858,
    height2: 858,
    width3: 1366,
    height3: 1366
};

const win = window;
const slight = CustomEase.create('slight', 'M0,0 C0.072,0 0.199,0.327 0.24,0.462 0.394,0.97 0.658,1 1,1');

const _getSvgToHtmlRatio = require('./svgAnim/getSvgToHtmlRatio');
const __getPointClass = require('./utils/getRiskValueClass');
const __clearPointClass = require('./utils/clearRiskValueClass');



const fromPolarToCartesian = require('./svgAnim/fromPolarToCartesian');
const simpleToCartesian = require('./svgAnim/simpleToCartesian');
const SizeMode = require('./utils/SizeMode');


const __getPolarPointsByValues = (arr, state) => {
    const n = arr.length;
    if (n < 1) return [];
    return arr.map((val, i) => {
        return fromPolarToCartesian(state.r * (state.rMinRatio + (state.rMaxRatio - state.rMinRatio) * val / 100), state.radShift + Math.PI * 2 * i / n, state);
    });
};

const __getPolarCubicLineByPoints = (arr, state) => {
    const n = arr.length;
    if (n < 3) return [];
    const da = Math.PI * 2 * state.curveRatio / n;

    let i;
    let a = state.radShift;
    let r1 = state.r * (state.rMinRatio + (state.rMaxRatio - state.rMinRatio) * arr[0] / 100);
    let r2 = r1 / Math.cos(da);
    const arr2 = [fromPolarToCartesian(r1, a, state)];
    let arrNext = fromPolarToCartesian(r2, a + da, state);
    for (i = 1; i < n; i++) {
        a = state.radShift + Math.PI * 2 * i / n;
        r1 = state.r * (state.rMinRatio + (state.rMaxRatio - state.rMinRatio) * arr[i] / 100);
        r2 = r1 / Math.cos(da);

        arr2.push([arrNext, fromPolarToCartesian(r2, a - da, state), fromPolarToCartesian(r1, a, state)]);
        arrNext = fromPolarToCartesian(r2, a + da, state);
    }

    a = state.radShift;
    r1 = state.r * (state.rMinRatio + (state.rMaxRatio - state.rMinRatio) * arr[0] / 100);
    r2 = r1 / Math.cos(da);
    arr2.push([arrNext, fromPolarToCartesian(r2, a - da, state), fromPolarToCartesian(r1, a, state)]);


    return arr2;
}



const __addIntermediateValues = (values, ratios) => {
    const arr = [];
    let i;
    // const ratios = [];
    for (i = 0; i < values.length - 1; i++) {
        // ratios.push(0.1 + Math.random() * 0.5);
        arr.push(values[i]);
        arr.push((values[i] + values[i + 1]) * ratios[i] / 2);
    }
    // ratios.push(0.05 + Math.random() * 0.6);
    arr.push(values[values.length - 1]);
    arr.push((values[values.length - 1] + values[0]) * ratios[values.length - 1] / 2);
    // console.log(ratios)
    return arr;
}



const init = function () {
    if (this._initiated) return this;

    this.svg1 = Snap(params.width1, params.height1);

    this.svg1.attr({viewBox: `${-params.width1 / 2} ${-params.height1 / 2} ${params.width1} ${params.height1}`});

    this.mainVP.appendChild(this.svg1.node);
    this.svg1.attr({'data-main-svg': true});

    this._stage = '';
    this._numFeaturesSelected = 0;
    this.activePointIndex = 0;
    this.activeIndex = -1;
    this._featuresTransformAngle = _noFeaturesTransformAngle;

    _construct(this);

    _lineInvalidate(this);
    _featuresInvalidateRound(this);
    _cameraInvalidate(this);

    TweenMax.delayedCall(0.1, _handleResize, [this]);

    this._initiated = true;
    return this;
};

const _setValues = function (values, curveMore, mode, delay) {
    const d = this;

    if (d._tl) d._tl.kill();

    d._values = values;
    d._prevExtValues = [].concat(d._realExtendedValues);
    d._prevValues = [].concat(d._realValues);
    d._extendedValues = __addIntermediateValues(values, d._ratios);
    d._transitionRatio = 0;
    if (!d._initiated) return;

    const slightBounceOut = CustomEase.create('slightBounceOut', 'M0,0,C0.162,0,0.096,1.031,0.316,1.032,0.406,1.032,0.38,1,1,1');
    const bounceOut = CustomEase.create('bounceOut', 'M0,0 C0.162,0 0.097,1.083 0.316,1.084 0.47,1.084 0.406,1 1,1');
    const slight = CustomEase.create('slight', 'M0,0 C0.072,0 0.199,0.327 0.24,0.462 0.394,0.97 0.658,1 1,1');
    let dur = 1;
    let ease = bounceOut;

    switch (mode) {
        case 1:
            dur = 2.1;
            ease = slightBounceOut;
            break;
        case 0:
            dur = 1;
            ease = slight;
            break;
    }

    const tl = new TimelineMax({
        delay: delay,
        onUpdate: function (diagram) {
            _lineInvalidate(diagram);
        },
        onUpdateParams: [d]
    });

    tl.to(d._state, dur, {
        curveRatio: curveMore ? 0.45 : 0.25,
        r: mode < 1 ? 1 : d._state.R,
        ease: ease
    }, 'st');

    tl.to(d, dur, {
        _transitionRatio: 1,
        ease: ease
    }, 'st');

    tl.to(d.lineGroup.node, dur * 0.3, {
        opacity: mode < 1 ? 0 : 1,
        ease: Sine.easeInOut
    }, 'st');

    d._tl = tl;

};


const _noFeaturesTransformAngle = a => { return a;};
const _portraitFeaturesTransformAngle = a => { const k = 0.63; return a < Math.PI * 0.5 ? a * k : a < Math.PI ? (a - Math.PI * 1.5) * k +  Math.PI * 1.5 : a; };

const _handleResize = d => {
    const sizeMode = SizeMode();
    d._svgToHtmlRatio = _getSvgToHtmlRatio(d.svg1);
    _labelsInvalidate(d);

    if (d.sizeMode !== sizeMode) {
        d._featuresTransformAngle = sizeMode === 'portrait' ? _portraitFeaturesTransformAngle : _noFeaturesTransformAngle;
        d.sizeMode = sizeMode;
        _updateFeaturesState(d, d._stage);
        return;
    }
    _featuresInvalidateRound(d);
}

const _construct = function (diagram) {
    const d = diagram;

    d._svgToHtmlRatio = _getSvgToHtmlRatio(d.svg1);
    d._featuresEl = d.mainVP.querySelector('[data-features]');
    d._labelsEl = d.mainVP.querySelector('[data-labels]');

    d._state = {
        rMin: 240 / 2,
        rMinRatio: 260 / 470,
        rMaxRatio: 1.05,
        r: 1,
        R: 470 / 2,
        cx: 0,
        cy: 0,
        radShift: 22.5 * Math.PI / 180,
        curveRatio: 0.25,
        labelsR: 560 / 2,
        totalShiftRatio: 0.3,
        labelsRatio: 0
    };
    d._realExtendedValues = [].concat(d._extendedValues);
    d._prevExtValues = [].concat(d._extendedValues);
    d._realValues = [].concat(d._values);
    d._prevValues = [].concat(d._values);

    const grnt = d.svg1.gradient(`r(0, 0, ${d._state.R})rgb(0,168,141,1)-rgb(0,168,141,1):60-rgba(237,28,35):70-rgba(237,28,35)`)
        .attr({
            gradientUnits: 'userSpaceOnUse'
        });

    d.lineGroup = d.svg1.g()
        .attr({
            opacity: 0
        });
    d.line = d.svg1.path(drawSVGUtils.joinCubicBezierPoints(__getPolarCubicLineByPoints(d._realExtendedValues, d._state)) + 'z')
        .attr({
            fill: 'none',
            stroke: grnt,
            strokeWidth: 3
        })
        .appendTo(d.lineGroup);

    const points = __getPolarPointsByValues(d._values, d._state);
    d.labels = [...d._labelsEl.querySelectorAll('[data-label]')];
    const n = points.length;

    d.axesLables = [...d._labelsEl.querySelectorAll('[data-axis]')];
    _fillAxesLabels(d.axesLables, [100, 0, 0, 100], [d._state.R, d._state.rMin, d._state.rMin, d._state.R], [0, 0, Math.PI, Math.PI], d._state);

    d.pointsG = [];
    d.points = [];
    d.labelsLines = [];

    points.forEach((val, i) => {
        const active = i === d.activePointIndex;
        const g = d.svg1.g()
            .attr({
                transform: `translate(${val[0]}, ${val[1]})`,
                class: __getPointClass(d._values[i])
            })
            .appendTo(d.lineGroup);
        const g2 = d.svg1.g()
            .attr({
                class: 'diagram__point'
            })
            .data({
                active: active
            })
            .appendTo(g);
        g2.attr({'data-active':  active});
        d.svg1.circle(0, 0, 20)
            .attr({
                fill: 'rgba(0,0,0,0)'
            })
            .appendTo(g2);

        d.svg1.circle(0, 0, 4)
            .appendTo(g2);
        d.points.push(g2);
        d.pointsG.push(g);

        const lbl = d.labels[i];
        lbl.data = lbl.data || {};
        lbl.data.a = d._state.radShift + Math.PI * 2 * i / n;

        lbl.dataset.selected = active;
        lbl.classList.add(__getPointClass(d._values[i]));

        const p = simpleToCartesian(d._state.labelsR, lbl.data.a);
        lbl.style.transform = `translate3d(${Math.round(p[0] * d._svgToHtmlRatio)}px, ${Math.round(p[1] * d._svgToHtmlRatio)}px, 0)`;

        const l = d.svg1.line(val[0], val[1], val[0], val[1])
            .attr({
                class: __getPointClass(d._values[i]),
                strokeWidth: 1
            })
            .data({
                ratio: active ? 1 : 0
            })
            .appendTo(d.lineGroup);

        d.labelsLines.push(l);
    });

    // Features
    const angles = [21, 45, 126, 195, 210, 230, 315, 338, 350];
    const __setFeatureData = (el, a, da) => {
        const data = el.data || {};
            data.r = 790 / 2;
            data.R = 790 / 2;
            data.a = -45 * Math.PI / 180;
            data.A0 = -45 * Math.PI / 180;
            data.A = a - da / 2 + Math.random() * da;
        el.data = data;
        el.style.opacity = 0;
    }

    d.features = [...d._featuresEl.querySelectorAll('[data-feature]')];
    d.features.forEach((el, i) => {
        __setFeatureData(el, angles[i] * Math.PI / 180, 0);
    });
};

const _fillAxesLabels = (labels, values, r, a, state) => {
    let i = 0;
    let lbl;
    const lbl0 = labels[0];
    while (values.length > 0) {
        if (i > labels.length - 1) {
            labels.push(labels[0].cloneNode(true));
        }
        lbl = labels[i];
        lbl.data = lbl.data || {};
        lbl.data.a = a[i];
        lbl.data.r = r[i];
        lbl.dataset.direction = (lbl.data.a > Math.PI * 0.5 && lbl.data.a < Math.PI * 1.5 ? -1 : 1) * ((lbl.data.r > state.R * (state.rMinRatio + 0.2) ? 1 : -1));
        lbl.querySelector('[data-axis-value]').innerHTML = values.shift();
        lbl0.parentNode.insertBefore(lbl, lbl0);
        i++;
    }
    while (i < labels.length) {
        lbl = labels.pop();
        if (lbl.parentNode) lbl.parentNode.removeChild(lbl);
    }
};

const _lineInvalidate = function (diagram) {
    const d = diagram;

    d._realExtendedValues = drawSVGUtils.getTransitionalPoints(d._prevExtValues, d._extendedValues, d._transitionRatio);
    d._realValues = drawSVGUtils.getTransitionalPoints(d._prevValues, d._values, d._transitionRatio);

    d.line.attr({
        d: drawSVGUtils.joinCubicBezierPoints(__getPolarCubicLineByPoints(d._realExtendedValues, d._state)) + 'z'
    });

    const points = __getPolarPointsByValues(d._realValues, d._state);

    points.forEach((val, i) => {
        const g = d.pointsG[i];
        const pointClass = __getPointClass(d._realValues[i]);
        g.attr({
            transform: `translate(${val[0]}, ${val[1]})`,
            class: pointClass
        });

        const lbl = d.labels[i];
        __clearPointClass(s => {lbl.classList.remove(s);});
        lbl.classList.add(pointClass);

    });

    _labelsInvalidate(d, points);

};

const _labelsInvalidate = function (diagram, points0) {
    const d = diagram;

    const points = points0 || __getPolarPointsByValues(d._realValues, d._state);
    const x2 = -d._state.cx * d._state.totalShiftRatio;
    const y2 = -d._state.cy * d._state.totalShiftRatio;
    points.forEach((val, i) => {

        const l = d.labelsLines[i];
        const ratio = l.data('ratio') * d._state.labelsRatio;
        if (ratio === 0) {
            l.attr({
                x1: val[0],
                y1: val[1],
                x2: val[0],
                y2: val[1],
                class: __getPointClass(d._values[i])
            })
                .appendTo(d.lineGroup);

            return;
        }


        const lbl = d.labels[i];
        const p = simpleToCartesian(d._state.labelsR, lbl.data.a);
        const p2 = [val[0] + ratio * (p[0] - val[0]), val[1] + ratio * (p[1] - val[1])];
        lbl.style.transform = `translate3d(${Math.round(p2[0] * d._svgToHtmlRatio)}px, ${Math.round(p2[1] * d._svgToHtmlRatio)}px, 0)`;

        l.attr({
            x1: val[0],
            y1: val[1],
            x2: p2[0] - x2,
            y2: p2[1] - y2,
            class: __getPointClass(d._values[i])
        })
            .appendTo(d.lineGroup);
    });
};

const _axesLabelsInvalidate = function (diagram) {
    const d = diagram;
    const x2 = -d._state.cx * d._state.totalShiftRatio;
    const y2 = -d._state.cy * d._state.totalShiftRatio;

    const ratio = d._state.r / d._state.R;
    d.axesLables.forEach(lbl => {
        const p = fromPolarToCartesian(lbl.data.r * ratio, lbl.data.a, d._state);
        lbl.style.transform = `translate3d(${Math.round((p[0] / ratio + x2) * d._svgToHtmlRatio)}px, ${Math.round((p[1] / ratio + y2) * d._svgToHtmlRatio)}px, 0)`;
    });
};

const _featuresInvalidate = diagram => {
    const d = diagram

    d.features.forEach(el => {
        const p = simpleToCartesian(el.data.r * d._svgToHtmlRatio, el.data.a);
        el.style.transform = `translate3d(${p[0]}px, ${p[1]}px, 0)`;
    });

};

const _clearFeaturesCSS = diagram => {
    const d = diagram;

    d.features.forEach(el => {
        el.style.transform = '';
        el.style.opacity = '';
    });

};

const _featuresInvalidateRound = diagram => {
    const d = diagram;

    d.features.forEach(el => {
        const p = simpleToCartesian(el.data.r * d._svgToHtmlRatio, el.data.a);
        el.style.transform = `translate3d(${Math.round(p[0])}px, ${Math.round(p[1])}px, 0)`;
    });

};

const _cameraInvalidate = diagram => {
    const d = diagram;

    const x2 = -d._state.cx * d._state.totalShiftRatio;
    const y2 = -d._state.cy * d._state.totalShiftRatio;


    // Total sectors shift
    d.lineGroup.attr({
        transform: `translate(${x2}, ${y2})`
    });

    _axesLabelsInvalidate(d);
};

const _animateFeaturesToState = (diagram, stage, prevStage, tl) => {
    const d = diagram;
    let changes = false;

    d.featuresSelected = [];
    d.activeIndexInSelection = 0;
    switch (stage) {
        case 'cover':
        case 'review':
            changes = prevStage === 'config' || prevStage === 'fix';

            d.features.forEach(p => {
                const data = p.data;
                tl.to(p, 0.5, {
                    opacity: 0
                }, 'st');
                tl.to(data, 1.1, {
                    r: data.R,
                    a: data.A0,
                    ease: slight
                }, 'st');
            });

            break;

        case 'config':
            changes = true;

            d.features.forEach(p => {
                const data = p.data;
                tl.to(p, 0.5, {
                    opacity: 1
                }, 'st');
                tl.to(data, 1.4, {
                    r: data.R,
                    a: d._featuresTransformAngle(data.A),
                    ease: slight
                }, 'st');
            });

            break;

        case 'fix':
            changes = true;

            d.features.forEach(p => {
                const data = p.data;
                if (data.active) d.activeIndexInSelection = d.featuresSelected.length;
                if (data.selected) {
                    data.indexInSelection = d.featuresSelected.length;
                    d.featuresSelected.push(p);
                }
            });
            d._numFeaturesSelected = d.featuresSelected.length;
            _animateFeaturesToOutlineActive(d, tl);

            break;
    }

    return changes;
};

const _updateFeaturesState = (diagram, stage) => {
    const d = diagram;

    switch (stage) {

        case 'config':

            d.features.forEach(p => {
                const data = p.data;
                TweenMax.set(p, {
                    opacity: 1
                }, 'st');
                TweenMax.set(data, {
                    r: data.R,
                    a: d._featuresTransformAngle(data.A),
                    ease: slight
                }, 'st');
            });

            break;
    }

};

const _animateFeaturesToOutlineActive = (diagram, tl) => {
    const d = diagram;

    const n = d.features.length;
    const n1 = d._numFeaturesSelected;
    let i = 0;
    d.features.forEach(p => {
        const data = p.data;
        const m = (n1 - 1) / n;
        tl.to(p, 0.5, {
            opacity: data.selected ? 1 : 0
        }, 'st');
        tl.to(data, 1.4, {
            r: n1 === 1 ? 0 : data.R * (0.08 + 0.25 * m),
            a: Math.PI * 2 * (i - d.activeIndexInSelection) / n1 + Math.PI / 2,
            ease: slight
        }, 'st');
        if (data.selected) i++;
    });

    return true;
};

const _updateDiagramState = (diagram, stage, prevStage) => {
    const d = diagram;

    d._featuresActive = stage === 'config' || stage === 'fix';
    d.mainVP.dataset.featuresActive = d._featuresActive;

    if (prevStage === 'cover') return;
    d._pointsActive = stage === 'review';
    d.mainVP.dataset.pointsActive = d._pointsActive;

};

const _updateDiagramState2 = (diagram, stage, prevStage) => {
    const d = diagram;
    if (prevStage !== 'cover') return;


    d._pointsActive = stage === 'review';
    d.mainVP.dataset.pointsActive = d._pointsActive;


};


const show = function () {
    if (!this._initiated) return this;
    if (this._shown) return this;

    this._shown = true;
    this._handleResize();
    _gotoCurrentStage(this);

    return this;
};

const hide = function () {
    if (!this._initiated) return this;
    return this;
};

const enable = function () {
    if (!this._initiated) return this;
    if (this._enabled) return this;
    this._handleResize();
    _addEventListeners(this, true);
    this._enabled = true;
    return this;
};

const disable = function () {
    if (!this._initiated) return this;
    if (!this._enabled) return this;
    _addEventListeners(this, false);
    this._enabled = false;
    return this;
};

const destroy = function () {
    if (!this._initiated) return this;
    this.disable();
    this.removeAllListeners();

    this.mainVP.dataset.featuresActive = true;
    this.mainVP.dataset.pointsActive = false;

    if (this.labelsLines)
        this.labelsLines.forEach(el => {
            TweenMax.killTweensOf(el.data());
        });

    _clearFeaturesCSS(this);

    TweenMax.killDelayedCallsTo(_handleResize);

    if (this._tl) this._tl.kill();
    this.svg1.remove();

    this._values = null;
    this._extendedValues.splice(0, this._extendedValues.length);
    this._realExtendedValues.splice(0, this._realExtendedValues.length);
    this._realValues.splice(0, this._realValues.length);

    this._enabled = false;
    this._shown = false;
    this._initiated = false;
    
    return this;
};

const goto = function (stage) {
    if (!this._initiated) return this;
    if (this._stage === stage) return this;
    this._prevStage = this._stage;
    this._stage = stage;

    if (this._shown)
        _gotoCurrentStage(this);

    return this;
};

const _setCenter = function (x, y) {
    if (!this._initiated) return this;
    this._state.centerChanged = true;
    this._state.cx = x;
    this._state.cy = y;
    if (this._shown) {
        _lineInvalidate(this);
        _cameraInvalidate(this);
        _labelsInvalidate(this);
    }
    return this;
};

const _gotoCurrentStage = diagram => {
    const d = diagram;

    _updateDiagramState(d, d._stage, d._prevStage);

    let featuresChanged = false;
    const tl = new TimelineMax({
        delay: 0/* state.delay*/,
        onUpdate: function () {
            _labelsInvalidate(d);
            _axesLabelsInvalidate(d);
            if (featuresChanged)
                _featuresInvalidate(d);
        },
        onComplete: function () {

            _axesLabelsInvalidate(d);
            if (featuresChanged)
                _featuresInvalidateRound(d);
        }
    });
    featuresChanged = _animateFeaturesToState(d, d._stage, d._prevStage, tl);

    tl.to(d.axesLables, 0.25, {
        opacity: d._stage === 'review' || d._stage === 'config' ? 1 : 0
    }, 'st+=' + ((d._stage === 'fix' ? 0.01 : 0.7) + (d._prevStage === 'cover' ? 2 : 0)));

    tl.to(d._state, 0.3, {
        labelsRatio: d._stage === 'review' ? 1 : 0,
        onStart: function () {
            _updateDiagramState2(d, d._stage, d._prevStage);
        }
    }, 'st+=' + (0.2 + (d._prevStage === 'cover' ? 2 : 0)));

};

const _select = (diagram, i) => {
    diagram.emit('select', i);
};

const _selectPoint = (diagram, i, el) => {
    if (diagram._stage !== 'review') return;
    if (i === diagram.activePointIndex) return;

    const j = diagram.activePointIndex;
    el.data({active: true});
    el.attr({'data-active': true});


    diagram.activePointIndex = i;

    // Label
    _showLabel(diagram, i);

    if (j > -1) {
        const prev = diagram.points[j];
        prev.data({active: false});
        prev.attr({'data-active': false});

        _hideLabel(diagram, j);
    }

    _select(diagram, i);
};

const _showLabel = (diagram, i) => {
    const lbl = diagram.labels[i];
    lbl.dataset.selected = true;
    _showLabelLine(diagram, i);
};

const _hideLabel = (diagram, i) => {
    if (i === diagram.activePointIndex) return;

    const lbl = diagram.labels[i];
    lbl.dataset.selected = false;
    _hideLabelLine(diagram, i);
};

const _showLabelLine = (diagram, i) => {
    const d = diagram;
    TweenMax.to(d.labelsLines[i].data(), 0.25, {
        delay: 0.15,
        ratio: 1,
        onUpdate: _labelsInvalidate,
        onUpdateParams: [d],
        ease: Sine.easeInOut
    });
};

const _hideLabelLine = (diagram, i) => {
    const d = diagram;
    TweenMax.to(d.labelsLines[i].data(), 0.2, {
        delay: 0.15,
        ratio: 0,
        onUpdate: _labelsInvalidate,
        onUpdateParams: [d],
        ease: Sine.easeInOut
    });
};

const _activateFeature = function (i) {
    const diagram = this;

    const el = diagram.features[i];

    diagram.activeIndex = i;

    diagram.activeIndexInSelection = el.data.indexInSelection;
    const tl = new TimelineMax({
        delay: 0.2,
        onUpdate: function () {
            _featuresInvalidate(diagram);
        },
        onComplete: function () {
            _featuresInvalidateRound(diagram);
        }
    });
    _animateFeaturesToOutlineActive(diagram, tl);
}

const _addEventListeners = (diagram, b) => {
    const d = diagram;

    if (b === false) {
        d.points.forEach(p => {
            let f = p.data('selectHandler');
            if (typeof f !== 'undefined') p.node.removeEventListener('click', f);
            f = p.data('overHandler');
            if (typeof f !== 'undefined') p.node.removeEventListener('mouseover', f);
            f = p.data('outHandler');
            if (typeof f !== 'undefined') p.node.removeEventListener('mouseout', f);
        });

        win.removeEventListener('resize', d._handleResize);
        return;
    }

    d.points.forEach((p, i) => {
        const f = () => {
            _selectPoint(d, i, p);
        };
        const over = () => {
            _showLabel(d, i);
        };
        const out = () => {
            _hideLabel(d, i);
        };
        p.data({
            selectHandler: f,
            overHandler: over,
            outHandler: out
        });
        p.node.addEventListener('click', f);
        p.node.addEventListener('mouseover', over);
        p.node.addEventListener('mouseout', out);
    });

    win.addEventListener('resize', d._handleResize);
}


module.exports = mainVP => {
    const Diagram = new EventEmitter();
    Diagram.mainVP = mainVP;
    Diagram._values = [];
    Diagram._extendedValues = [];
    Diagram._realExtendedValues = [];
    Diagram._realValues = [];
    Diagram._ratios = [0.37059098825884507, 0.5926941210750883, 0.504830790912504, 0.11728542373535636, 0.42044551706988786, 0.32035943848854553, 0.1972318425699016, 0.2560814560158048, 0.24759929042954712, 0.4776228421991778];


    Diagram.init = init.bind(Diagram);
    Diagram.destroy = destroy.bind(Diagram);
    Diagram.enable = enable.bind(Diagram);
    Diagram.disable = disable.bind(Diagram);
    Diagram.show = show.bind(Diagram);
    Diagram.hide = hide.bind(Diagram);
    Diagram.goto = goto.bind(Diagram);
    Diagram.setCenter = _setCenter.bind(Diagram);
    Diagram.setValues = _setValues.bind(Diagram);
    Diagram.activateFeature = _activateFeature.bind(Diagram);
    Diagram._handleResize = () => { _handleResize(Diagram) };

    return Diagram;
};


// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/CentralDiagram.js